import * as moment from 'moment';

export function sanitizeServerUtcDate(date: moment.Moment | string): moment.Moment {
  return moment.utc(date);
}

export function correctDateTimeForOffset(
  dateTimeUtc: moment.Moment,
  offsetHours: number,
  isUtcContext: boolean,
  isUtcReturnValue: boolean
) {
  const returnDate = dateTimeUtc.clone().utcOffset(offsetHours, !isUtcContext);
  if (isUtcReturnValue) {
    returnDate.utc();
  }
  return returnDate;
}

export function applyTimeZoneOffset(date: Date): Date {
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + offset);
}

// prevents bad dates from causing sql timeouts
export function isDateSqlValid(date: moment.Moment): boolean {
  const minDate = new Date(1753, 1, 1);
  const maxDate = new Date(9999, 12, 31);

  return date.isValid() && date.isBetween(minDate, maxDate);
}
